/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { FuelPricingMode } from './FuelPricingMode';
import {
    FuelPricingModeFromJSON,
    FuelPricingModeFromJSONTyped,
    FuelPricingModeToJSON,
    FuelPricingModeToJSONTyped,
} from './FuelPricingMode';

/**
 * 
 * @export
 * @interface EntryTokenCompetition
 */
export interface EntryTokenCompetition {
    /**
     * 
     * @type {string}
     * @memberof EntryTokenCompetition
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof EntryTokenCompetition
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof EntryTokenCompetition
     */
    slug?: string;
    /**
     * 
     * @type {string}
     * @memberof EntryTokenCompetition
     */
    gameId?: string;
    /**
     * Display name of the game, resolved from gameId. Absent when the competition is not game-scoped.
     * @type {string}
     * @memberof EntryTokenCompetition
     */
    gameName?: string;
    /**
     * Board lifecycle status. Whether an occurrence is open comes from startAt/endAt, not this.
     * @type {string}
     * @memberof EntryTokenCompetition
     */
    status: string;
    /**
     * DAILY / WEEKLY / MONTHLY / CUSTOM / ONE_TIME — the cadence label shown beside the schedule.
     * @type {string}
     * @memberof EntryTokenCompetition
     */
    periodType?: string;
    /**
     * Unix ms the current-or-next occurrence opens, for the "opens Fri 7pm" line.
     * @type {number}
     * @memberof EntryTokenCompetition
     */
    startAt?: number;
    /**
     * Unix ms the current-or-next occurrence closes, for the "ends Fri 11:59pm" line. Absent on a board with no end.
     * @type {number}
     * @memberof EntryTokenCompetition
     */
    endAt?: number;
    /**
     * The advertised pool. Display only — the payable amount is derived from escrow at settlement.
     * @type {number}
     * @memberof EntryTokenCompetition
     */
    prizePoolTotal?: number;
    /**
     * 
     * @type {string}
     * @memberof EntryTokenCompetition
     */
    prizePoolCurrency?: string;
    /**
     * The Devour-committed FLOOR in USD dollars, when the board carries one. A floor, never added on top.
     * @type {number}
     * @memberof EntryTokenCompetition
     */
    guaranteedPoolUsd?: number;
    /**
     * True when a token is the ONLY way in, so no Fuel alternative is offered.
     * @type {boolean}
     * @memberof EntryTokenCompetition
     */
    tokenOnly: boolean;
    /**
     * The Fuel-side price when one exists, so the UI can say "1 Token or $5". Absent on a token-only competition. DOLLARS, not cents, when fuelPricingMode is USD_EQUIVALENT — leaderboards store whole dollars. See processEntryFee.ts for why that distinction has already cost a 100x payout error once.
     * @type {number}
     * @memberof EntryTokenCompetition
     */
    entryFee?: number;
    /**
     * 
     * @type {FuelPricingMode}
     * @memberof EntryTokenCompetition
     */
    fuelPricingMode?: FuelPricingMode;
}



/**
 * Check if a given object implements the EntryTokenCompetition interface.
 */
export function instanceOfEntryTokenCompetition(value: object): value is EntryTokenCompetition {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('tokenOnly' in value) || value['tokenOnly'] === undefined) return false;
    return true;
}

export function EntryTokenCompetitionFromJSON(json: any): EntryTokenCompetition {
    return EntryTokenCompetitionFromJSONTyped(json, false);
}

export function EntryTokenCompetitionFromJSONTyped(json: any, ignoreDiscriminator: boolean): EntryTokenCompetition {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'slug': json['slug'] == null ? undefined : json['slug'],
        'gameId': json['gameId'] == null ? undefined : json['gameId'],
        'gameName': json['gameName'] == null ? undefined : json['gameName'],
        'status': json['status'],
        'periodType': json['periodType'] == null ? undefined : json['periodType'],
        'startAt': json['startAt'] == null ? undefined : json['startAt'],
        'endAt': json['endAt'] == null ? undefined : json['endAt'],
        'prizePoolTotal': json['prizePoolTotal'] == null ? undefined : json['prizePoolTotal'],
        'prizePoolCurrency': json['prizePoolCurrency'] == null ? undefined : json['prizePoolCurrency'],
        'guaranteedPoolUsd': json['guaranteedPoolUsd'] == null ? undefined : json['guaranteedPoolUsd'],
        'tokenOnly': json['tokenOnly'],
        'entryFee': json['entryFee'] == null ? undefined : json['entryFee'],
        'fuelPricingMode': json['fuelPricingMode'] == null ? undefined : FuelPricingModeFromJSON(json['fuelPricingMode']),
    };
}

export function EntryTokenCompetitionToJSON(json: any): EntryTokenCompetition {
    return EntryTokenCompetitionToJSONTyped(json, false);
}

export function EntryTokenCompetitionToJSONTyped(value?: EntryTokenCompetition | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'slug': value['slug'],
        'gameId': value['gameId'],
        'gameName': value['gameName'],
        'status': value['status'],
        'periodType': value['periodType'],
        'startAt': value['startAt'],
        'endAt': value['endAt'],
        'prizePoolTotal': value['prizePoolTotal'],
        'prizePoolCurrency': value['prizePoolCurrency'],
        'guaranteedPoolUsd': value['guaranteedPoolUsd'],
        'tokenOnly': value['tokenOnly'],
        'entryFee': value['entryFee'],
        'fuelPricingMode': FuelPricingModeToJSON(value['fuelPricingMode']),
    };
}

